import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { Category } from '../models/category';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class CategoryService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public getByParent(parent_Category_Id: number): Promise<Category[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Category[]>(environment.apiUrl + 'category/getall?parent_Category_Id=' + parent_Category_Id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public getAll(): Promise<Category[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Category[]>(environment.apiUrl + 'category/getall').subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public get(id: Number): Promise<Category> {
    return new Promise((resolve, reject) => {
      this.http.get<Category>(environment.apiUrl + 'category/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public save(category: Category): Promise<Category> {
    return new Promise((resolve, reject) => {
      if (category.is_edit) {
        this.http.put<Category>(environment.apiUrl + 'category/put', category).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated category');
        }, error => {
          //console.log(error);
          reject();
        });
      } else {
        this.http.post<Category>(environment.apiUrl + 'category/post', category).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added category');
        }, error => {
          //console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, name: string): Promise<PagedData<Category>> {
    const pagedData = new PagedData<Category>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&name=' + name;

      this.http.get<ServerData>(environment.apiUrl + 'category/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });


  }
}
